module.exports = __webpack_public_path__ + "static/media/logo-kpc@2x.3391ba78.png";